module.exports = __webpack_public_path__ + "img/default-nav-subnav-hyundai.abe873ee.png";